import {
  faFolder,
  faFolderOpen,
  faChevronDown,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import LayersCard from "./LayersCard";

const RESTRICTED_PATHS = [
  "Smuszewo/Geophysics Figures",
  "Smuszewo/Geo-Environmental Data",
  "Smuszewo/Site Plans",
  "Roseninsel/Site Plans",
  "Les Argilliez/Site Plans",
  "Kalapodi/Site Plans",
  "Choirokitia/Site Plans",
];

const LayersGroup = ({
  jsonFile,
  prevGroupName,
  fullPath,
  setLayerName,
  setLayersThatWereSwitchedNames,
  setSwitchIsOn,
  setShowTooltip,
  setLayerOpacity,
  setBoundingBox,
  setButtonOn,
  checkedAll,
  setCheckedAll,
  layersThatWereSwitchedNames,
  activeLayers,
  setActiveLayers,
  searchTerm,
}) => {
  const [collapsed, setCollapsed] = useState(false);

  let isLayer = false;
  let groupId = "";

  if (jsonFile.Name) {
    isLayer = true;
  }
  // console.log(jsonFile, "jsonFileSto Group");

  // Check Restricted Access
  const userRole = localStorage.getItem("userRole");
  const isRestricted = userRole === "guest" && RESTRICTED_PATHS.includes(fullPath);

  return (
    <>
      {isLayer ? (
        <LayersCard
          jsonFile={prevGroupName}
          prevGroupName={prevGroupName}
          fullPath={fullPath}
          objectContent={jsonFile}
          setLayerName={setLayerName}
          setLayersThatWereSwitchedNames={setLayersThatWereSwitchedNames}
          setSwitchIsOn={setSwitchIsOn}
          setShowTooltip={setShowTooltip}
          setLayerOpacity={setLayerOpacity}
          setBoundingBox={setBoundingBox}
          setButtonOn={setButtonOn}
          checkedAll={checkedAll}
          setCheckedAll={setCheckedAll}
          layersThatWereSwitchedNames={layersThatWereSwitchedNames}
          activeLayers={activeLayers}
          setActiveLayers={setActiveLayers}
          searchTerm={searchTerm}
        />
      ) : (
        <div className="parent-group" id={`parent-group-${groupId}`}>
          <div
            className="group-card"
            id={`group-${groupId}`}
            onClick={() => {
              if (!isRestricted) {
                 setCollapsed(!collapsed);
              }
            }}
            style={isRestricted ? { opacity: 0.6, cursor: "not-allowed", backgroundColor: "#f0f0f0" } : {}}
          >
            <div className="group-title">
              {isRestricted ? (
                <FontAwesomeIcon icon={faLock} style={{ marginRight: "5px", color: "#555" }} />
              ) : collapsed ? (
                <FontAwesomeIcon icon={faFolderOpen} />
              ) : (
                <FontAwesomeIcon icon={faFolder} />
              )}
              {prevGroupName.replace(/_/g, " ")}
            </div>
            <div className="group-card-chevron">
              {!isRestricted && (
                collapsed ? (
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    style={{
                      transform: "rotate(180deg)",
                      transition: "0.3s ease",
                    }}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    style={{ transition: "0.3s ease" }}
                  />
                )
              )}
            </div>
          </div>
          <div
            className="inner-group-container"
            id={`inner-group-container-${groupId}`}
          >
            {collapsed && !isRestricted &&
              Object.keys(jsonFile).map((subGroup, index) => {
                const childFullPath = fullPath ? `${fullPath}/${subGroup}` : subGroup;
                return (
                  <LayersGroup
                    jsonFile={jsonFile[subGroup]}
                    key={index}
                    prevGroupName={subGroup}
                    fullPath={childFullPath}
                    setLayerName={setLayerName}
                    setLayersThatWereSwitchedNames={
                      setLayersThatWereSwitchedNames
                    }
                    layersThatWereSwitchedNames={layersThatWereSwitchedNames}
                    setSwitchIsOn={setSwitchIsOn}
                    setShowTooltip={setShowTooltip}
                    setLayerOpacity={setLayerOpacity}
                    setBoundingBox={setBoundingBox}
                    setButtonOn={setButtonOn}
                    checkedAll={checkedAll}
                    setCheckedAll={setCheckedAll}
                    activeLayers={activeLayers}
                    setActiveLayers={setActiveLayers}
                  />
                );
              })}
          </div>
        </div>
      )}
    </>
  );
};

export default LayersGroup;